import {Utilities} from '@shared/utilities/utilities.model';

export class CCDashboardModel {
	stats: Map<string, CCDashboardStatModel>;

	constructor(model?: any) {
		this.stats = new Map<string, CCDashboardStatModel>();
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.stats)) {
			for (const stat of model.stats) {
				if (!Utilities.isVoid(stat.state)) {
					this.stats.set(stat.state, new CCDashboardStatModel(stat));
				}
			}
		}
	}
}

export class CCDashboardStatModel {
	state: string;
	count = 0;

	with_surveyor = 0;
	without_surveyor = 0;
	with_template = 0;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.state = model.state;
			this.count = isNaN(+model.count) ? 0 : +model.count;
			this.with_surveyor = isNaN(+model.with_surveyor) ? 0 : +model.with_surveyor;
			this.without_surveyor = isNaN(+model.without_surveyor) ? 0 : +model.without_surveyor;
			this.with_template = isNaN(+model.with_template) ? 0 : +model.with_template;
		}
	}
}